export interface ILoginoplysninger {
    nuvaerendeKodeord: string;
    nytKodeord: string;
    gentagNytKodeord: string;
    brugerId: number;
}
